import { segmentAnalytics } from '@hungryroot/segment';
import { type TriggerInteractionEventArgs } from '../RDPModal';

export function sendInteractionEvent({
  orderId,
  id,
  name,
  interactionType,
}: TriggerInteractionEventArgs) {
  segmentAnalytics.track('Pairing Interaction', {
    event_name: 'Pairing Interaction',
    order_id: orderId,
    pairing_id: id,
    pairing_name: name,
    interaction_type: interactionType,
    page_name: 'RDP',
  });
}
